import Stack from "@mui/material/Stack";
import { FC } from "react";
import { BreakAfterDurationField } from "@sinch/components/application/RateInterval/CreateInterval/BreakPenalty/BreakAfterDurationField";
import { BreakPenaltyProvider } from "@sinch/components/application/RateInterval/CreateInterval/BreakPenalty/BreakPenaltyProvider";
import { BreakRequiredLengthField } from "@sinch/components/application/RateInterval/CreateInterval/BreakPenalty/BreakRequiredLengthField";
import { CustomPenaltyLengthField } from "@sinch/components/application/RateInterval/CreateInterval/BreakPenalty/CustomPenaltyLengthField";
import { PenaltyComponentsField } from "@sinch/components/application/RateInterval/CreateInterval/BreakPenalty/PenaltyComponentsField";
import { PenaltyCustomComponentField } from "@sinch/components/application/RateInterval/CreateInterval/BreakPenalty/PenaltyCustomComponentField";
import { PenaltyDurationField } from "@sinch/components/application/RateInterval/CreateInterval/BreakPenalty/PenaltyDurationField";

/**
 * Editor for a CustomIntervalType.BREAK_PENALTY interval: a break of a required length is expected
 * every so often and each missed one is penalized under the picked rate components.
 */
export const BreakPenaltySettings: FC<{ disabled?: boolean; path?: string }> = ({ disabled, path = "settings" }) => (
  <BreakPenaltyProvider disabled={disabled} path={path}>
    <Stack spacing={2}>
      <BreakAfterDurationField />
      <BreakRequiredLengthField />
      <CustomPenaltyLengthField />
      <PenaltyDurationField />
      <PenaltyComponentsField />
      <PenaltyCustomComponentField />
    </Stack>
  </BreakPenaltyProvider>
);
